import React from 'react';
import { Star, RefreshCw, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

export default function ReviewsTab({
  reviews, fetchReviews, formatDate, actionLoading, handleDeleteReview,
  reviewsPage, reviewsTotalPages, setReviewsPage
}) {
  return (
    <div className="space-y-4" data-testid="reviews-tab">
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="font-semibold text-gray-900">All Reviews</h3>
          <Button onClick={fetchReviews} variant="outline" size="sm">
            <RefreshCw className="h-4 w-4" />
          </Button>
        </div>
        <div className="divide-y divide-gray-200">
          {reviews.map((review) => (
            <div key={review._id} className="p-4 hover:bg-gray-50" data-testid={`review-${review._id}`}>
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="flex">
                      {[0, 1, 2, 3, 4].map((i) => (
                        <Star key={`star-${review._id}-${i}`} className={`h-4 w-4 ${i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
                      ))}
                    </div>
                    <span className="text-sm text-gray-500">{formatDate(review.created_at)}</span>
                  </div>
                  <p className="font-medium text-gray-900 mb-1">{review.title}</p>
                  <p className="text-gray-600 text-sm mb-2">{review.content}</p>
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>From: {review.reviewer?.name || 'Unknown'}</span>
                    <span>To: {review.reviewee?.name || 'Unknown'}</span>
                  </div>
                </div>
                <Button size="sm" variant="outline" onClick={() => handleDeleteReview(review._id)} disabled={actionLoading === review._id} className="text-red-600 hover:bg-red-50 ml-4">
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <p className="text-sm text-gray-500">Page {reviewsPage} of {reviewsTotalPages}</p>
          <div className="flex space-x-2">
            <Button size="sm" variant="outline" disabled={reviewsPage === 1} onClick={() => setReviewsPage(p => p - 1)}>
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <Button size="sm" variant="outline" disabled={reviewsPage >= reviewsTotalPages} onClick={() => setReviewsPage(p => p + 1)}>
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
